import { rosterWindowSettingsContract } from "@clipboard-health/contract-backend-main";
import { useGetParsedQuery } from "@src/appV2/api/useGetParsedQuery";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { type UseQueryResult } from "@tanstack/react-query";

import { type RosterWindowSettings } from "../types";
import { rosterWindowSettingsUrl } from "./rosterWindowSettingsUrl";

interface UseGetRosterWindowSettingsParams {
  workplaceId: string;
  enabled?: boolean;
}

export function useGetRosterWindowSettings(
  params: UseGetRosterWindowSettingsParams
): UseQueryResult<RosterWindowSettings> {
  const { workplaceId, enabled = true } = params;

  return useGetParsedQuery({
    url: rosterWindowSettingsUrl(workplaceId),
    responseSchema: rosterWindowSettingsContract.getSettings.responses[200],
    select: (envelope) => ({
      workplaceId: envelope.data.id,
      longLeadThresholdDays: envelope.data.attributes.longLeadThresholdDays,
      longLeadOpenDaysBeforeStart: envelope.data.attributes.longLeadOpenDaysBeforeStart,
      shortLeadOpenDaysAfterPosting: envelope.data.attributes.shortLeadOpenDaysAfterPosting,
      urgentThresholdDays: envelope.data.attributes.urgentThresholdDays,
      updatedAt: envelope.data.attributes.updatedAt,
    }),
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_ROSTER_WINDOW_SETTINGS_FAILURE,
    },
    enabled,
  });
}
